import { useTranslation } from "react-i18next";
import { appPaths } from "../../../shared/routing/appPaths";
import ButtonLink from "../../../ui/buttons/ButtonLink";
import GetTheConnector, { ConnectThisPc } from "../GetTheConnector";
import { browserOffer, useConnectorDownloads } from "../useConnectorDownloads";
import CommandFold from "../CommandFold";
import PairCommand from "../PairCommand";

/**
 * Connecting a PC that has no connector yet (F78, F85, F86): download it, open it, enter the
 * code it shows. On Linux and macOS, where the release has packages, one command installs it,
 * starts it and pairs (RE-7): its only other step is the approval, in the browser it opens or
 * with the code it shows. The server sees a pairing only, never an installation, so the steps
 * don't claim one. The pair command stays the backup for people who use a terminal (F47),
 * folded away; building from source is not that backup. The setup guide's pair step and
 * Profile › Connect this PC share it.
 */
export default function ConnectSteps() {
  const { t } = useTranslation();
  const { downloads, reload } = useConnectorDownloads();
  const byCommand = browserOffer(downloads)?.kind === "command";
  return (
    <div className="space-y-4">
      <ol className="list-decimal space-y-4 pl-5 marker:font-semibold">
        <li className="space-y-2">
          <h3 className="app-title text-sm font-semibold">{t(byCommand ? "connectors.connect.installByCommand" : "connectors.connect.download")}</h3>
          <GetTheConnector downloads={downloads} reload={reload} />
        </li>
        {byCommand ? null : (
          <li className="space-y-2">
            <h3 className="app-title text-sm font-semibold">{t("connectors.connect.open")}</h3>
            <ConnectThisPc />
          </li>
        )}
        <li className="space-y-2">
          <h3 className="app-title text-sm font-semibold">{t(byCommand ? "connectors.connect.approve" : "connectors.connect.enterCode")}</h3>
          {byCommand ? <p className="app-help-text text-xs">{t("connectors.connect.approveNote")}</p> : null}
          <ButtonLink to={appPaths.connectorPairing()} size="xs">{t("connectors.list.enterCode")}</ButtonLink>
        </li>
      </ol>
      {/* The terminal's way stays, folded away: a historian needs the three steps (TR-A1-05). */}
      <CommandFold>
        <PairCommand />
      </CommandFold>
    </div>
  );
}
